import React from 'react';
// Emotion
import {keyframes} from '@emotion/react';
// MUI
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Fade from '@mui/material/Fade';

// Styles
import {makeStyles} from 'tss-react/mui';
import {useHistory} from 'react-router-dom';
// Animación simple con CSS keyframes
const slideIn = keyframes`
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const useStyles = makeStyles()(theme => ({
   signUpButton: {
      boxShadow:
         '0 1px 1px 0 rgba(0,0,0,0.14), 0 2px 1px -1px rgba(0,0,0,0.12), 0 1px 3px 0 rgba(0,0,0,0.20)',
      backgroundColor: '#FFFFFF',
      color: 'black',
      '&:hover': {
         backgroundColor: '#d5d5d5'
      },
      padding: theme.spacing(1, 3)
   },
   successCard: {
      animation: `${slideIn} 0.5s ease-out`,
      textAlign: 'center',
      padding: theme.spacing(4)
   },
   actionButtons: {
      marginTop: theme.spacing(3),
      '& > *': {
         margin: theme.spacing(1)
      }
   },
   successIcon: {
      fontSize: 64,
      color: theme.palette.success.main,
      marginBottom: theme.spacing(2)
   }
}));

export interface DSSignUpExitoProps {
   registroExitoso: boolean;
   loginUrl: string;
}

const DSSignUpExito: React.FC<DSSignUpExitoProps> = ({registroExitoso, loginUrl}) => {
   const {classes} = useStyles();
   const history = useHistory();

   const handleVolverLogin = (): void => {
      history.push(loginUrl);
   };

   return (
      <Container style={{height: '100%'}} component="main" maxWidth="sm">
         <Fade in={registroExitoso} timeout={500}>
            <div className={classes.successCard}>
               <Grid container spacing={2}>
                  <Card style={{maxWidth: 450, padding: 16, width: '100%'}}>
                     <CardMedia
                        component="img"
                        height="auto"
                        image="https://www.dscont.pe/dsServices/images/ds-iso9001-logo.png"
                        alt="Data Service Capacitacion SRL."
                        style={{
                           width: '90%',
                           padding: 2,
                           justifySelf: 'center',
                           margin: '0 auto'
                        }}
                     />
                     <CardContent>
                        <Grid container spacing={2}>
                           <Grid item xs={12}>
                              <Alert severity="success" variant="filled">
                                 <AlertTitle>¡Registro Exitoso!</AlertTitle>
                                 Se ha enviado una contraseña segura a su correo.
                              </Alert>
                           </Grid>
                           <Grid item xs={12} className={classes.actionButtons}>
                              <Button
                                 variant="contained"
                                 color="primary"
                                 onClick={handleVolverLogin}
                                 size="large"
                              >
                                 Volver a Log In
                              </Button>
                           </Grid>
                        </Grid>
                     </CardContent>
                  </Card>
               </Grid>
            </div>
         </Fade>
      </Container>
   );
};

export default DSSignUpExito;
